import type { ComponentType, SVGProps } from "react";
import {
  BellIcon,
  ChartBarIcon,
  ChartPieIcon,
  CodeBracketIcon,
  CurrencyDollarIcon,
  DocumentTextIcon,
  FingerPrintIcon,
  GiftIcon,
  LanguageIcon,
  MegaphoneIcon,
  MoonIcon,
  RocketLaunchIcon,
  ShieldCheckIcon,
  SparklesIcon,
  SwatchIcon,
  TrophyIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";

export type HeroIcon = ComponentType<SVGProps<SVGSVGElement>>;

/** Icon keys stored in announcements.icon. */
export const ANNOUNCEMENT_ICONS: Record<string, HeroIcon> = {
  megaphone: MegaphoneIcon,
  sparkles: SparklesIcon,
  trophy: TrophyIcon,
  "code-bracket": CodeBracketIcon,
  "document-text": DocumentTextIcon,
  "chart-bar": ChartBarIcon,
  "chart-pie": ChartPieIcon,
  "currency-dollar": CurrencyDollarIcon,
  moon: MoonIcon,
  "finger-print": FingerPrintIcon,
  users: UsersIcon,
  language: LanguageIcon,
  swatch: SwatchIcon,
  bell: BellIcon,
  gift: GiftIcon,
  rocket: RocketLaunchIcon,
  shield: ShieldCheckIcon,
};

export const ANNOUNCEMENT_ICON_KEYS = Object.keys(ANNOUNCEMENT_ICONS);

export function getAnnouncementIcon(key?: string | null): HeroIcon {
  return (key && ANNOUNCEMENT_ICONS[key]) || MegaphoneIcon;
}
